import axios from "axios";

const api=axios.create({baseURL:""});

export const getPost = () =>
{
  return api.get("/posts");
}

export const getTask = () =>
{
  return api.get("/tasks");
}

export const apiAddTaskAssign=(addAssinedTask)=>
{
    //console.log('/tasksAssign'+addAssinedTask.description);
    console.log(JSON.stringify(addAssinedTask));
    return api.post('/tasksAssign',addAssinedTask);
}

export const addAProject = (addProject) =>
{
  return api.post("/projects",addProject);
}

export const addATask = (addTask) =>
{
  return api.post("/tasks",addTask);
}

export const editATask = (addProject) =>
{
  console.log("/tasks/"+addProject.id);

  return api.put("/tasks/"+addProject.id,addProject);
}

export const editAProject = (addProject) =>
{
  console.log("100/projects/"+addProject.id);

  return api.put("/projects/"+addProject.id,addProject);
}

export const editUser = (addUser) =>
{
  console.log("100/users/"+addUser.id);

  return api.put("/users/"+addUser.id,addUser);
}

export const editAssgnedTask = (addAssinedTask) =>
{
  console.log(JSON.stringify(addAssinedTask));
  console.log("100/users/"+addAssinedTask.id);
  return api.put("/tasksAssign/"+addAssinedTask.id,addAssinedTask);
}

export const addAUser = (addUser) =>
{
  return api.post("/users",addUser);
}

export const deletePost=(id)=>
{
    console.log('/posts/'+id);
    return api.delete('/posts/37');
}


export const deleteProject=(id)=>
{
    console.log('/projects/'+id);
    return api.delete('/projects/'+id);
}

export const getLogin=()=>
{
    //console.log('/users/login);
    return api.post('/users/login');
}

export const getProjects = () =>
{
  return api.get("/projects");
  //return ({"result":true,"msg":"Project list available","data":[{"id":1,"title":"JVHospital","description":"JVH jaipur","time_line":"02\/08\/2025","created_by":"admin1"},{"id":2,"title":"title","description":"description","time_line":"31\/06\/2025","created_by":"manager"},{"id":3,"title":"title","description":"description","time_line":"time_line","created_by":"admin1"},{"id":4,"title":"title","description":"description","time_line":"time_line","created_by":"admin1"},{"id":5,"title":"title","description":"description","time_line":"time_line","created_by":"admin1"}]})
}
//,"role":[{"id":1,"role":"Admin","id":2,"role":"Manager","id":3,"role":"User","id":4,"role":"It"}],
export const getUsers = () =>
{
  return api.get("/users/role");
  //return ({"result": true,"msg": "User list available","rolelist":[{"id":1,"role":"Admin"},{"id":2,"role":"Manager"},{"id":3,"role":"User"},{"id":4,"role":"It"}],"data": [{"id": "4","name": "Backend Developer","contact": "contact","email": "email@gmail.com","status": "1","role": "user"},{"id": "5","name": "Backend Developer","contact": "contact","email": "email@gmail.com","status": "1","role": "IT"},{"id": "8","name": "John Doe","contact": "1234567890","email": "john@example.com","status": "1","role": "Admin"},{"id": "9","name": "John Doe","contact": "1234567890","email": "john@example.com","status": "1","role": "Manager"},{"id": "6","name": "John Doe","contact": "1234567890","email": "john@example.com","status": "1","role": "Admin"}]})
}

export const getAssignedTasks = () =>
{
  return api.get("/tasksAssign");
}

export const getAssignedTasksStatus = () =>
{
  console.log("/tasksAssign/task/"+localStorage.getItem("id"));
  return api.get("/tasksAssign/task/"+localStorage.getItem("id"));
}

export const getSupportiveStatus = ($id) =>
{
  console.log("/supportivetasks/tasks/"+$id);
  return api.get("/supportivetasks/tasks/"+$id);
}

export const deleteAssignedTasks = (id) =>
{
  return api.delete("/tasksAssign/"+id);
}

export const deleteUser = (id) =>
{
  return api.delete("/users/"+id);
}

export const deleteTasks = (id) =>
{
  return api.delete("/tasks/"+id);
}
